import * as React from "react";
import * as ReactDOM from "react-dom/client";
import Dashboard from "./Dashboard";
import ErrorPage from "./error-page";
import MainGrid from './components/MainGrid';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import "./index.css";
import Root from "./routes/root";
import SignIn from "./components/signin/SignIn"
import App from "./App"





ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <App  />
    </React.StrictMode>
);